import {DepotoCore, OAuthToken} from 'depoto-core'
// import { User } from 'depoto-core'
import { OAuthSession } from 'depoto-core'
import { User } from 'depoto-core'
// import { OAuthSession } from 'depoto-core/src/models'
// import { User } from 'depoto-core/src/entities'
import { wait } from '../../utils'

export enum LOGIN {
  INIT = 'LOGIN_INIT',
  SUCCESS = 'LOGIN_SUCCESS',
  ERROR = 'LOGIN_ERROR',
  TERMINATE = 'LOGIN_TERMINATE',
  LOGOUT = 'LOGIN_LOGOUT',
}

const PROFILE_FETCH_ATTEMPTS = 3

const authenticate = async (
  email: string,
  password: string,
  environment: string,
  customUrl: string,
  core: DepotoCore,
) => {
  const session: OAuthSession = new OAuthSession({
    email: email,
    password,
    clientType: environment,
    isRememberMe: true,
  })
  if (environment === 'custom' && customUrl?.length > 0) {
    session.clientCustomUri = customUrl
  }
  session.clientId = '36_27y4bbpod2m8skgk4scwsc8gcw4c044s40gcw44swcc4s0s4kk'
  session.clientSecret = '53gxznakf44kowsgs8ww4csk8080k8wkk0s84kcswk80c48og0'
  try {
    return await core.services.oauth.getToken(session)
  } catch (e) {
    console.warn(e)
  }
}

function login() {
  return {
    type: LOGIN.INIT,
  }
}

function success(user: User, session: OAuthSession) {
  return {
    type: LOGIN.SUCCESS,
    payload: { user, session },
  }
}

function failed(error: string) {
  return {
    type: LOGIN.ERROR,
    payload: error,
  }
}

function terminate() {
  return {
    type: LOGIN.TERMINATE,
  }
}

export function handleLogin(email: string, password: string, environment: string, customUrl: string, core: DepotoCore) {
  return async function (dispatch: any) {
    dispatch(login())
    try {
      if (customUrl?.length > 7) {
        window.localStorage.setItem('depoto_server_custom_url', customUrl)
      } else {
        window.localStorage.removeItem('depoto_server_custom_url')
      }
      const isAuth = await authenticate(email, password, environment, customUrl, core)
      if (isAuth) {
        const session = {...core.services.oauth.session}
        await core.services.user.setCurrentUser(email)
        if (core.services.user.user) {
          window.depotoEnv = <'prod' | 'stage' | 'dev' | 'custom'>environment
          dispatch(success(core.services.user.user!, session))
          return true
        } else {
          dispatch(failed('profile fetch error'))
          return false
        }
      } else {
        dispatch(failed('login error'))
        return false
      }
    } catch (error: any) {
      dispatch(failed(error.response.data))
      return false
    }
  }
}

export function handleLoginByPin(session: OAuthSession, core: DepotoCore) {
  return async function (dispatch: any) {
    dispatch(login())
    try {
      // console.log({...session}, session.email, session.password, session.clientType)
      const isAuth = await authenticate(session.email, session.password, session.clientType, undefined, core)
      if (isAuth) {
        const session = {...core.services.oauth.session}
        await core.services.user.setCurrentUser(session.email)
        if (core.services.user.user) {
          window.depotoEnv = <'prod' | 'stage' | 'dev' | 'custom'>session.clientType
          dispatch(success(core.services.user.user!, session))
          return true
        } else {
          dispatch(failed('profile fetch error'))
          return false
        }
      } else {
        dispatch(failed('login error'))
        return false
      }
    } catch (error: any) {
      dispatch(failed(error.response.data))
      return false
    }
  }
}

export function handleLoginBySessionSwitch(session: OAuthSession, core: DepotoCore) {
  return async function (dispatch: any) {
    dispatch(login())
    try {
      core.services.oauth.session = session
      await core.services.user.setCurrentUser(session.email)
      if (core.services.user.user) {
        window.depotoEnv = <'prod' | 'stage' | 'dev' | 'custom'>session.clientType
        dispatch(success(core.services.user.user!, session))
        return true
      } else {
        dispatch(failed('profile fetch error'))
        return false
      }
    } catch (error: any) {
      dispatch(failed(error.response.data))
      return false
    }
  }
}

export const handleAuthInit = (core: DepotoCore) => async (dispatch: any) => {
  const isAuth = core.services.oauth.isAuthenticated()
  console.log('handleauthinit')
  // Let the state storage remain it the initial state
  if (!isAuth || !core.services.oauth?.session?.token) {
    return
  }

  core.services.oauth.session.clientId = '36_27y4bbpod2m8skgk4scwsc8gcw4c044s40gcw44swcc4s0s4kk'
  core.services.oauth.session.clientSecret = '53gxznakf44kowsgs8ww4csk8080k8wkk0s84kcswk80c48og0'

  const { token, email } = core.services.oauth?.session || {}
  const { timestamp, expiresIn } = token || {}

  // Check if access token is expired by expiresIn field
  if (timestamp && expiresIn && Date.now() - timestamp > (expiresIn - 60) * 1000) {
    const isRefreshed = await core.services.oauth.getRefreshToken()

    if (!isRefreshed) {
      dispatch(terminate())
      return
    }
  }

  // Let the core to fetch the user profile 3 times
  // There is a condition when accessToken is expired earlier that expiresIn
  // and this is braking above refresh logic. f.e. when expiring token directly from DB

  for (let i = 0; i < PROFILE_FETCH_ATTEMPTS; i++) {
    await core.services.user.setCurrentUser(email)
    const user = core.services.user.user
    const session = {...core.services.oauth.session}
    if (user) {
      dispatch(success(user, session))
      break
    } else {
      await wait(300)
    }
  }
}

export function handleLogout(core: DepotoCore) {
  // We don't need to logout if we are not authenticated
  if (core.services?.oauth?.session?.isAuthenticated) {
    core.services.oauth.logout()
  }

  return {
    type: LOGIN.LOGOUT,
  }
}

function decodeQueryParam(value: string): string {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '))
  } catch {
    return value
  }
}

export function handleExternalLogin(core: DepotoCore, search: string) {
  return async function (dispatch: any) {
    dispatch(login())
    try {
      const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
      const access_token = params.get('access_token')
      const refresh_token = params.get('refresh_token')
      if (!access_token?.length || !refresh_token?.length) {
        dispatch(failed('Missing access_token or refresh_token in URL'))
        return false
      }

      const session = new OAuthSession()
      session.token.accessToken = decodeQueryParam(access_token)
      session.token.refreshToken = decodeQueryParam(refresh_token)
      session.token.tokenType = params.get('token_type') || 'Bearer'
      session.token.scope = params.get('scope') || ''
      session.token.expiresIn = Number(params.get('expires_in') || 0)
      session.token.timestamp = Date.now()
      session.clientType = params.get('serverUrl') === 'https://server1.depoto.cz' ? 'prod' : 'stage'
      session.isAuthenticated = true
      session.isRememberMe = true
      session.clientId = '36_27y4bbpod2m8skgk4scwsc8gcw4c044s40gcw44swcc4s0s4kk'
      session.clientSecret = '53gxznakf44kowsgs8ww4csk8080k8wkk0s84kcswk80c48og0'
      core.services.oauth.session = session
      window.depotoEnv = session.clientType as 'prod' | 'stage' | 'dev' | 'custom'

      const userProfile = await core.services.user.getMyProfile({ id: null, email: null, name: null })
      if (!userProfile?.email) {
        core.services.oauth.logout()
        dispatch(failed('Failed to load user profile'))
        return false
      }

      session.email = userProfile.email
      core.services.oauth.session = session
      ;(core.services.oauth as { saveData?: () => void }).saveData?.()

      await core.services.user.setCurrentUser(userProfile.email)
      const user = core.services.user.user
      if (user) {
        dispatch(success(user, session))
        return true
      }
      core.services.oauth.logout()
      dispatch(failed('Failed to load user after setCurrentUser'))
      return false
    } catch (error: unknown) {
      core.services.oauth.logout()
      const msg =
        error && typeof error === 'object' && 'message' in error && typeof (error as Error).message === 'string'
          ? (error as Error).message
          : 'External login failed'
      dispatch(failed(msg))
      return false
    }
  }
}
